export default "__VITE_ASSET__DZPkLNho__"